<span class="bv-checkbox__box">
  <svg class="bv-checkbox__check" viewBox="0 0 16 16" aria-hidden="true">
    <polyline
      points="3.5,8.5 7,12 12.5,5"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</span>
<span class="bv-checkbox__label">
  <ng-content></ng-content>
</span>
